export default __webpack_public_path__ + "static/reviseVideo-c62bf69ff7aafd77bdb96ac6dc542585.mp4";